<template>
  <div>
    <el-container>
      <sub-header :subHeaderConfig="subHeaderConfig" />
    </el-container>
    <div class="y-content-ctr">
      <div class="form">
        <div class="form-content clearfix">
          <div>
            <div class="form-row" v-for="(component, index) in channelForm" :key="index">
              <v-layout
                align-start
                justify-start
                v-if="component.controlName === 'titleBar'"
                class="titleBar clearfix"
              >
                <v-flex lg12>
                  <div class="stepHeader">
                    <v-layout :class="[component.customClass, 'form-control']">
                      <v-flex>
                        <span>{{component.displayName}}</span>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
              <div class="form-item-ctr">
                <div class="form-item">
                  <conditional-render :dataProps="component" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footerBtnCtr">
          <v-layout justify-end>
            <template v-for="(action, index) in actionData">
              <div v-if="action.controlName === 'button'" :key="index">
                <v-btn
                  :color="action.actionType"
                  :outlined="action.outlined"
                  depressed
                  @click="handle_function_call(action.actionMethod)"
                >{{ action.displayName }}</v-btn>
              </div>
            </template>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import SubHeader from '../../components/subheader.vue'
import ConditionalRender from '../../components/conditionalRender.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import { mapActions } from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
import serviceRegistery from '../../mixins/serviceRegistery'
import { jsonHelper } from '../../mixins/jsonHelper'
import { helpers } from '../../mixins/helpers'
import { subbrandToolHelper } from '../../mixins/subbrandToolHelper'
export default {
  data: () => ({}),
  $_veeValidate: {
    validator: 'new'
  },
  provide() {
    return {
      $validator: this.$validator
    }
  },
  created: function() {
    var self = this
    this.$store.commit('updateSamlFormShowHide', this.channelForm)

    this.$validator.extend(
      'isNotSame',
      {
        getMessage: field => 'The ' + field + ' value should be unique.',
        validate: (value, [otherValue]) => {
          var otherDefaultValue = $('.' + otherValue + ' input').val()
          return value != otherDefaultValue
        }
      },
      {
        hasTarget: true
      }
    )

    this.$validator.extend(
      'isNotSameTextArea',
      {
        getMessage: field => 'The ' + field + ' value should be unique.',
        validate: (value, [otherValue]) => {
          var otherDefaultValue = $('.' + otherValue + ' textarea').val()
          return value != otherDefaultValue
        }
      },
      {
        hasTarget: true
      }
    )
  },
  mixins: [jsonHelper, subbrandToolHelper, helpers],
  components: {
    'conditional-render': ConditionalRender,
    'sub-header': SubHeader
  },
  computed: {
    subHeaderConfig() {
      let config = {
        headerText: 'Channel Config',
        backLink: {
          text: this.$route.params.backText,
          link: this.$route.params.backLink
        }
      }
      return config
    },
    channelForm() {
      return this.$store.state.channelStore.channelFormData.content[0].form
    },
    actionData() {
      return this.$store.state.channelStore.channelFormData.content[0].actions
    }
  },
  methods: {
    ...mapActions([]),
    constructSubbrandData() {
      let subbrandData = this.channelForm
      let configData = {}
      let formData = subbrandData
      for (let j = 0; j <= formData.length - 1; j++) {
        if (formData[j] && formData[j].key) {
          this.assignFormDataObject(configData, formData[j])
        }
        if (
          (formData[j].controlName === 'formGroup' ||
            formData[j].controlName === 'productGroup') &&
          formData[j].show != false
        ) {
          let fromGroupData = formData[j].formData
          for (let l = 0; l <= fromGroupData.length - 1; l++) {
            if (fromGroupData[l] && fromGroupData[l].key) {
              this.assignFormDataObject(configData, fromGroupData[l])
            }

            let subFromGroupData = fromGroupData[l].formData
            if(subFromGroupData) {
                for (let k = 0; k <= subFromGroupData.length - 1; k++) {
                    if (subFromGroupData[k] && subFromGroupData[k].key) {
                    this.assignFormDataObject(configData, subFromGroupData[k])
                    }

                    let childFromGroupData = subFromGroupData[k].formData
                    if(childFromGroupData) {
                        for (let n = 0; n <= childFromGroupData.length - 1; n++) {
                            if (childFromGroupData[n] && childFromGroupData[n].key) {
                            this.assignFormDataObject(configData, childFromGroupData[n])
                            }
                        }
                    }
                }
            }
          }
        }
      }
      return configData
    },
    assignFormDataObject(configData, formData) {
      let validData = this.filterValidData(formData)
      if (typeof validData !== 'undefined') {
        configData[formData.key] = validData
        if (formData.sdpKey && formData.sdpValue) {
          configData[formData.sdpKey] = formData.sdpValue
        }
      }
    },
    filterValidData(data) {
      let validData
      if (typeof data.defaultValue !== 'undefined') {
        if (data.dataType === 'string' && data.defaultValue) {
          if (data.controlName == 'textArea') {
            validData = data.defaultValue.replace(/\\n/g, '')
          } else {
            validData = data.defaultValue
          }
        } else if (data.dataType === 'array' && data.defaultValue.length > 0) {
          validData = data.defaultValue
        } else if (data.dataType === 'boolean') {
          validData = data.defaultValue
        }
      }
      return validData
    },
    saveChannelConfig() {
      console.log('save called')
      let configData = this.constructSubbrandData()
      let subbrandDataObj = this.dotNotationJsonToObject(configData)
      // subbrandDataObj.configStatus = this.getConfigFlowData()
      let _id = this.$store.state.channelStore.selectedChannelInfo._id

      this.$validator.validateAll().then(result => {
        if (result) {
          let serviceURL
          if (_id === undefined) {
            serviceURL = this.$hostname + 'services/channel/create'
            subbrandDataObj.cobrandId = subbrandDataObj.config.cobrandId
          } else {
            serviceURL = this.$hostname + 'services/channel/update'
          }

          let reqObj = {
            id: _id,
            jsonData: JSON.stringify(subbrandDataObj)
          }

          if (subbrandDataObj.labelFile === undefined) {
            serviceRegistery
              .makeCall({
                url: serviceURL,
                method: 'PUT',
                data: reqObj
              })
              .then(response => {
                console.log('Channel craetion/update success')
                this.$router.push('/channel/channelDataloader')
              })
              .catch(error => {
                this.showToastMessage(
                  'Sorry, a technical error has occurred! Please try again later.'
                )
                console.log(
                  'Error while Creating/Updating Channel',
                  error.response.data
                )
              })
          } else {
            var formdata = new FormData()
            formdata.append('resource', subbrandDataObj.labelFile)
            formdata.append('id', _id)
            formdata.append('jsonData', JSON.stringify(subbrandDataObj))
            axios
              .put(serviceURL, formdata, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(response => {
                console.log('Channel craetion/update success')
                this.$router.push('/channel/channelDataloader')
              })
              .catch(() => {
                console.log(
                  'Error while Creating/Updating Channel',
                  error.response.data
                )
              })
          }
        } else {
          console.log('ERROR', this.$validator)
        }
      })
    }
  }
}
</script>

<style scoped>
.y-content-ctr {
  margin: 20px;
}
</style>
